import { useSociete, useTiersService } from '@europrocurement/l2d-domain';
import {
    PrescripteursApiGetListTiersTiersCollection0Request,
    PrescripteursApiGetTiersTiersItem0Request,
    TiersTiersJsonldTiersReadNoteGroupTimestampableBlameambleGroup,
} from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { filtersToElasticQuery } from '@europrocurement/l2d-redux-utils';

export type Tiers = TiersTiersJsonldTiersReadNoteGroupTimestampableBlameambleGroup &
    Record<string, unknown>;

const useOffrePrescripteur = () => {
    const { prescribersApi } = useTiersService();
    const xIdSociete = useSociete();

    let getPrescriberTimeout: number | undefined;

    const getPrescriber = (prescriberSearch: string | number): Promise<Array<Tiers>> =>
        new Promise((resolve, reject) => {
            clearTimeout(getPrescriberTimeout);
            if (typeof prescriberSearch === 'number') {
                // Recherche par ID
                const requestParameters: PrescripteursApiGetTiersTiersItem0Request = {
                    id: prescriberSearch,
                    xIdSociete,
                };

                prescribersApi
                    .getTiersTiersItem(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Tiers[]))
                    .catch((error) => reject(error));
            } else {
                // Recherche par texte
                const parameterQuery: Record<string, unknown> = {
                    isPrescripteur: true,
                };

                if (prescriberSearch.trim() !== '') {
                    parameterQuery.raisonSociale = prescriberSearch.trim();
                }

                const query = filtersToElasticQuery(parameterQuery);

                const requestParameters: PrescripteursApiGetListTiersTiersCollection0Request = {
                    search: query,
                    xIdSociete,
                };

                prescribersApi
                    .getListTiersTiersCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Tiers[]))
                    .catch((error) => reject(error));
            }
        });

    return { getPrescriber };
};

export default useOffrePrescripteur;
